import { getDataProperty } from '../utils/_domFunctions';
import { handleErrors } from '../utils/_handleErrors';

class mAccountAddressBook extends HTMLDivElement {
    constructor() {
        super();
        this.addressSelector = this.querySelector('[is="m-address-selector"]');

        // Setup m-address-selector events
        this.addressSelector.addEventListener('change', this.onAddressSelectorChange.bind(this));
        this.addressSelector.addEventListener('savecardedition', this.onAddressSelectorSaveCard.bind(this));
    }

    /**
     * Send the new default/prefered address to the back-end
     * @param {string} addressId New default address ID
     */
    sendDefaultAddress(addressId) {
        const setDefaultUrl = new URL(getDataProperty(this, 'setDefaultUrl', 'string'));
        setDefaultUrl.searchParams.set('addressId', addressId);
        fetch(setDefaultUrl, { method: 'GET' })
            .then(handleErrors);
    }

    onAddressSelectorChange(event) {
        if (event.currentTarget !== event.target) {
            // Filter out change event from other elements
            return;
        }
        this.sendDefaultAddress(event.detail.addressId);
    }

    onAddressSelectorSaveCard(event) {
        const card = event.target;
        const { oldAddressId, newAddressId, templates } = event.detail;

        // Update address card selector
        this.addressSelectors.forEach((selector) => {
            if (selector === event.currentTarget) {
                return;
            }

            if (card.dataset.mode === 'addition') {
                selector.addNewAddressCard(event.detail.templates.addressSelectorCard);
            } else {
                selector.updateAddressCard(
                    oldAddressId,
                    newAddressId,
                    templates?.addressSelectorCardSummary,
                );
            }
        });
    }
}

customElements.define('m-account-address-book', mAccountAddressBook, {
    extends: 'div',
});
